import React, { useState, useContext, useCallback, memo } from 'react';
import { Flex, Drawer, Pagination, Input, Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { CATEGORIES_PAID } from './items/paid-assets';
/* import ShoppingCart from '@ozoneuniverse/ui-components/build-pkg/src/components/shopping-cart/ShoppingCart'; */
import { SearchOutlined } from '@ant-design/icons';
/* import { ShoppingCartContext } from '@ozoneuniverse/ui-components/build-pkg/src/components/shopping-cart/ShoppingCartProvider'; */
import { ProductCard } from '@ozoneuniverse/ui-components/build-pkg/src/components/asset-store/products/ProductCard';
import { useGetAssetsWeb2Query } from '@src/components/generated/graphql';
import { debounce } from 'lodash';
import ModelViewerModal from './ModelViewer';
import styles from './web2-assets-store.module.css';

const PAGE_LIMIT = 18;

const Cards = ({ loading, assets, onOpenPreview }) => {
  return (
    <Flex gap={20} wrap='wrap'>
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 30, color: '#000' }} spin />
          }
        />
      ) : (
        <>
          {assets?.length ? (
            assets?.map((el, i) => {
              return (
                <ProductCard
                  product={el}
                  disablePreview={el.assetURL.includes('AssetPack.gltf')}
                  disableLink={true}
                  type='web2'
                  key={i}
                  imgOnClick={
                    el.assetURL.includes('AssetPack.gltf')
                      ? undefined
                      : () => onOpenPreview(el.assetURL)
                  }
                />
              );
            })
          ) : (
            <>Sorry, no found assets</>
          )}
        </>
      )}
    </Flex>
  );
};

const CardsMemo = memo(Cards);

export default function Web2AssetsDrawer({ isOpen, setIsOpen, userEmail }) {
  /*   const { cart } = useContext(ShoppingCartContext as any) as any; */
  const [currentPage, setCurrentPage] = useState(1);
  const [filterType, setFilterType] = useState('all');
  const [previewOpen, setPreviewOpen] = useState(false);
  const [modelUrl, setModelUrl] = useState('');
  const [activeCategory, setActiveCategory] = useState(0);
  const [searchInput, setSearchInput] = useState(undefined);
  const [active, setActive] = useState(0);

  const { data, loading } = useGetAssetsWeb2Query({
    variables: {
      where: {
        offset: PAGE_LIMIT * (currentPage - 1),
        limit: PAGE_LIMIT,
        filter: {
          type: filterType,
          searchInput: searchInput,
          excludeTags: ['skins', 'new collection'],
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const assets = data?.getAssetsWeb2.assets;

  const getResults = debounce(async (name) => {
    setActiveCategory(0);
    setCurrentPage(1);
    setSearchInput(name);
  }, 800);

  const onOpenPreview = useCallback((url) => {
    setPreviewOpen(true);
    setModelUrl(url);
  }, []);

  const onSearch = async (input) => {
    if (input.target.value.length <= 1) {
      getResults.cancel();
      return setSearchInput(undefined);
    }

    return getResults(input.target.value);
  };

  const resetFilters = useCallback(() => {
    setSearchInput(undefined);
    setActiveCategory(0);
    setCurrentPage(1);
  }, []);

  const handleCategoryClick = useCallback((category, index) => {
    setSearchInput(category.tag.toLowerCase());
    setActiveCategory(index + 1);
    setCurrentPage(1);
  }, []);

  return (
    <>
      <Drawer
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeIcon={false}
        footer={false}
        zIndex={1001}
        className={styles.assetsDrawer}
        width={'90%'}
        title={
          <>
            <h3 style={{ marginBottom: 20 }}>Asset Store</h3>
            <Flex align='center' justify='space-between'>
              <Flex align='flex-start' gap={25}>
                <Button
                  data-cy='assets-store-all'
                  onClick={() => {
                    setActive(0);
                    setFilterType('all');
                    resetFilters();
                  }}
                  className={`${active === 0 && styles.active} ${
                    styles.button
                  }`}
                >
                  <span className={styles.buttonText}>All</span>
                </Button>
                <Button
                  data-cy='assets-store-prefabs'
                  onClick={() => {
                    setActive(1);
                    setFilterType('prefab');
                    resetFilters();
                  }}
                  className={`${active === 1 && styles.active} ${
                    styles.button
                  }`}
                >
                  <span className={styles.buttonText}>Prefabs</span>
                </Button>
                <Button
                  data-cy='assets-store-single-assets'
                  onClick={() => {
                    setActive(2);
                    setFilterType('single_asset');
                    resetFilters();
                  }}
                  className={`${active === 2 && styles.active} ${
                    styles.button
                  }`}
                >
                  <span className={styles.buttonText}>Single assets</span>
                </Button>
              </Flex>
              <Flex className={styles.cartButton}>
                <Input
                  placeholder='Search assets'
                  className={styles.search}
                  onChange={onSearch}
                  prefix={<SearchOutlined className={styles.iconSearch} />}
                />
                <div data-cy='asset-store-cart'>
                  {/*   <ShoppingCart
                    data={cart?.map((i) => ({
                      ...i,
                      price: parseFloat(i.price),
                    }))}
                    userEmail={userEmail}
                  /> */}
                </div>
              </Flex>
            </Flex>
            <Flex align='center' gap={5} style={{ marginTop: 10 }}>
              <Button
                onClick={resetFilters}
                className={`${activeCategory === 0 && styles.categoryActive} ${
                  styles.categoryButton
                }`}
              >
                <span className={styles.buttonText}>All</span>
              </Button>
              {filterType !== 'prefab' &&
                CATEGORIES_PAID.map((category, index) => (
                  <Button
                    key={index}
                    onClick={() => handleCategoryClick(category, index)}
                    className={`${
                      activeCategory === index + 1 && styles.categoryActive
                    } ${styles.categoryButton}`}
                  >
                    <span className={styles.buttonText}>{category.name}</span>
                  </Button>
                ))}
            </Flex>
          </>
        }
      >
        <CardsMemo
          loading={loading}
          onOpenPreview={onOpenPreview}
          assets={assets}
        />
        <Flex justify='center'>
          <Pagination
            defaultCurrent={1}
            current={currentPage}
            pageSize={PAGE_LIMIT}
            total={data?.getAssetsWeb2.totalCount}
            hideOnSinglePage
            showSizeChanger={false}
            onChange={(page) => {
              setCurrentPage(page);
            }}
            className={styles.pagination}
          />
        </Flex>
        <ModelViewerModal
          open={previewOpen}
          setOpen={setPreviewOpen}
          modelUrl={modelUrl}
        />
      </Drawer>
    </>
  );
}
